import CrosswordCell from '../models/CrosswordCell'
import router from '@/router'
import api from '@puzzleapps/shared/src/utils/api'

import {
    state as baseState,
    getters as baseGetters,
    actions as baseActions,
    mutations as baseMutations,
} from '@puzzleapps/shared/src/store/modules/grid'

// TODO: Make cells array one dimensional
const state = {
    ...baseState,
    isAcross: true, // crossword specific
    groups: true, // crossword specific
}

const getters = {
    ...baseGetters,

    noNeighbouringCells: state => (row, col) => {
        let cells = state.cells
        return (
            (state.isAcross && 
            (!cells[row][col+1] || cells[row][col+1].isBlack) &&
            (!cells[row][col-1] || cells[row][col-1].isBlack) ) ||
            (!state.isAcross && 
            (!cells[row+1] || cells[row+1][col].isBlack) &&
            (!cells[row-1] || cells[row-1][col].isBlack) ) 
        )
    },

}

function noNeighbouringCells1()
{
return true;

}
const actions = {
    ...baseActions,

    fetchPuzzle({ commit, dispatch, rootState, state }) {
        commit('SET_LOADED', false)            
        commit('SET_SELECTED_CELL', null)        

        return new Promise((resolve, reject) => {

            let puzzleId = rootState.game.puzzleId
            if (!puzzleId) throw new Error('Puzzle id must be specified.')
        
            api.data(puzzleId)
                .then(data => {
                    commit('SET_CROSSWORD_GRID', data)
                    dispatch('loadUserDataFromLocal', puzzleId)
                    commit('SET_LOADED', true)
                    dispatch('setCrosswordStart')
                    resolve(data)
                    
                })     
        })
    },
    setInputAtPos({ commit, dispatch, state, rootState, getters }, payload) {
        
        if (!payload) 
            throw new Error('Cell row and payload required. Given: ' + payload)

        let cell = state.cells[payload.row][payload.col]

        if (cell.input == payload.input) return

        commit('SET_USER_INPUT_AT_POS', payload)
        dispatch('checkCompleted')
    },
}

const mutations = {
    ...baseMutations,
    // example json data
    // {"r":9,
    // "c":9,
    // "w":[
    //     {"s":"PRETTY","ct":"Lovely","d":0,"r":"0","c":"2","cn":1},
    //     {"s":"GLOBE","ct":"Orb","d":0,"r":"1","c":"1","cn":5},
    //     {"s":"SLUMBERED","ct":"Dozed","d":0,"r":"2","c":"0","cn":7},
    //     {"s":"WINE","ct":"Bacchus's drink","d":0,"r":"3","c":"0","cn":10},
    //     {"s":"SOLO","ct":"Song for one","d":0,"r":"3","c":"5","cn":11},
    //     {"s":"ADD","ct":"Contribute","d":0,"r":"4","c":"0","cn":12},
    //     {"s":"TAR","ct":"Destructive cigarette component","d":0,"r":"4","c":"6","cn":13},
    //     {"s":"MEEK","ct":"Humble","d":0,"r":"5","c":"0","cn":14},
    //     {"s":"FATE","ct":"Doom","d":0,"r":"5","c":"5","cn":16},
    //     {"s":"IRRIGATED","ct":"Supplied with water","d":0,"r":"6","c":"0","cn":17},
    //     {"s":"CEDED","ct":"Yielded","d":0,"r":"7","c":"3","cn":19},
    //     {"s":"ANKLES","ct":"Leg joints","d":0,"r":"8","c":"1","cn":20},
    //     {"s":"PLUNDER","ct":"Pillage","d":1,"r":"0","c":"2","cn":1},
    //     {"s":"ROME","ct":"The Eternal City","d":1,"r":"0","c":"3","cn":2},
    //     {"s":"EBB","ct":"Peter out","d":1,"r":"0","c":"4","cn":3},
    //     {"s":"TEES","ct":"Golf ball holders","d":1,"r":"0","c":"5","cn":4},
    //     {"s":"GLIDER","ct":"Unpowered plane","d":1,"r":"1","c":"1","cn":5},
    //     {"s":"ADORED","ct":"Loved","d":1,"r":"1","c":"8","cn":6},
    //     {"s":"SWAMIS","ct":"Indian gurus","d":1,"r":"2","c":"0","cn":7},
    //     {"s":"ROTATES","ct":"Swaps (tyre) positions","d":1,"r":"2","c":"6","cn":8},
    //     {"s":"ELATED","ct":"Greatly pleased","d":1,"r":"2","c":"7","cn":9},
    //     {"s":"KICK","ct":"Begin, ... off","d":1,"r":"5","c":"3","cn":15},
    //     {"s":"FADE","ct":"Dwindle","d":1,"r":"5","c":"5","cn":16},
    //     {"s":"GEL","ct":"Hair product","d":1,"r":"6","c":"4","cn":18}
    // ]}
    SET_CROSSWORD_GRID(state, json) {
        if (process.env.NODE_ENV === 'development') {
            console.log('SET_CROSSWORD_GRID')
            console.log('state', state)
        }


        state.cols = json.c
        state.rows = json.r

        // create empty cells
        let cells = []

        for (let i = 0; i < state.rows; i++) {
            let row = []
                        
            for (let j = 0; j < state.cols; j++) {

                let cell = new CrosswordCell()                
                cell.row = i
                cell.col = j
                row.push(cell)
            }
            
            cells.push(row)
        }

        state.cells = cells        

        // add letters to grid
        for (let i in json.w) {
            let line = json.w[i]
            // {"s":"PRETTY","ct":"Lovely","d":0,"r":"0","c":"2","cn":1}

            // convert solution to cell positions
            let word = line.s.split('')
            let row = line.r
            let col = line.c
            let across = (line.d == 0)
            
            cells[row][col].clueNumber = line.cn
            
            word.map(letter => {
                cells[row][col].words[(across ? 'across' : 'down')] = line.s
                cells[row][col].solution = letter
                cells[row][col].isBlack = false
                across ? col++ : row++
            })
        }
        
    },
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}